import React from 'react';

const TimelineItem = ({ heading, color }) => (
  <div className="jd-timeline-svg-heading">
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <circle
          cx="20"
          cy="20"
          r="19.5"
          transform="rotate(90 20 20)"
          fill="#F8F8F8"
          stroke={color}
        />
        <circle
          cx="20"
          cy="20"
          r="9.5"
          transform="rotate(90 20 20)"
          fill={color}
          stroke={color}
        />
        {color === '#2576BC' && (
          <path
            d="M25 16L17.3077 23.01L15 20.9091"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        )}
        {color === '#F7BA1E' && (
          <path
            // d="M25 16L17.3077 23.01L15 20.9091"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        )}
      </svg>
    </div>
    <span className={` width-5vw   ${color === '#2576BC' ? ' timeline-color' : ''}`}>
      {heading}
    </span>
  </div>
);

const CareerStepItem = ({ step, heading, status }) => {

  const statusClass = `career-step-status-${status}`;

  return (
    <div className={`career-step-item ${statusClass}`}>

      <div className="career-step-circle">

        {status === "completed" ? (
          <svg width="14" height="14" viewBox="0 0 24 24">
            <path
              d="M20 6L9 17L4 12"
              stroke="white"
              strokeWidth="3"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <span>{step}</span>
        )}

      </div>

      <div className="career-step-text">
        {heading}
      </div>

    </div>
  );
};

export default TimelineItem
export { CareerStepItem }

